import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ClientForm from '../components/shared/ClientForm';
import { appendLicenseFields, toYmd } from '../components/shared/clientFormConfig';
import { PageHeader, toast } from '../components/ui';
import { usePageCrumbs } from '../components/shell';
import { addEntreprise } from '../servicesV2/entrepriseService';

function NewClient() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState('');

  usePageCrumbs([{ label: 'Nouveau client' }]);

  const handleSubmit = async ({ data, modules, keptModules, color, logo }) => {
    setLoading(true);
    setErrorText('');
    try {
      const formData = new FormData();
      formData.append('Activite', data.Activite);
      formData.append('DomainApplication', data.DomainApplication);
      formData.append('JustificationExclusion', data.JustificationExclusion || '');
      formData.append('Key', data.Key);
      formData.append('Nom', data.Nom);
      formData.append('RaisonSocial', data.RaisonSocial);
      // Plain YYYY-MM-DD: toISOString() shifted the day back in UTC+1, and the
      // licence signs exactly these dates.
      formData.append('endDate', toYmd(data.endDate));
      formData.append('representantEmail', data.representantEmail);
      formData.append('representantName', data.representantName);
      formData.append('startDate', toYmd(data.startDate));
      formData.append('color', color || '');
      formData.append('isOnPremise', data.isOnPremise ? 'true' : 'false');
      if (data.isOnPremise) formData.append('publicApiUrl', data.publicApiUrl || '');
      if (logo) formData.append('PieceJointe', logo);
      modules.forEach((m) => formData.append('modules[]', m));
      appendLicenseFields(formData, data, keptModules);

      await addEntreprise(formData);
      toast.success('Client créé', { description: data.Nom });
      navigate('/clients');
    } catch (err) {
      const serverKey = err?.response?.data?.message;
      const message = serverKey
        ? t(`ERRORS.${serverKey}`, { defaultValue: serverKey })
        : t('ERRORS.ERROR', { defaultValue: 'Une erreur est survenue.' });
      setErrorText(message);
      toast.error('Échec de la création', { description: message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader
        title="Nouveau client"
        description="Créer un tenant sur la plateforme Betterfly."
      />
      <ClientForm
        mode="create"
        showColor
        submitLabel="Créer le client"
        onSubmit={handleSubmit}
        onCancel={() => navigate('/clients')}
        errorText={errorText}
        loading={loading}
      />
    </>
  );
}

export default NewClient;
